import { createContext, useContext, useReducer } from "react";

// Create the context
const appContext = createContext();

// Custom hook to use the context
export const useAdminContext = () => {
  return useContext(appContext);
};

// Reducer function to handle actions
function adminAppReducer(state, action) {
  switch (action.type) {
    case "SET_EDITED":
      return {
        ...state, // Spread the existing state
        isEdited: action.payload, // Update only `isEdited`
      };
    case "SET_OPENED_WINDOW":
      return {
        ...state, // Spread the existing state
        openedWindow: [...state.openedWindow, action.payload], // Add new window
      };

    case "COMPANY_NAME":
      return {
        ...state,
        companyName: action.payload,
      };
    case "SET_EDITED_USERPROV":
      return { ...state, isEditedUserProv: action.payload };

    case "SET_EDITED_SSO":
      return { ...state, isEditedSso: action.payload };
    default:
      return state; // Return unchanged state for unknown actions
  }
}

// Context provider
export const AdminContextProvider = ({ children }) => {
  // Initial state: You can have more values here if needed
  const initialState = {
    isEdited: false, // Default is 
    isEditedUserProv: false,
    isEditedSso: false,
    JsonObj: {}, // Initial empty JSON object
    formDataObj: {}, // Initial empty form data object
    finalJson: {}, // Initial empty final JSON result
    openedWindow: [],
    companyName: "",
  };

  const [adminAppState, adminAppDispatcher] = useReducer(
    adminAppReducer,
    initialState
  );

  // Function to set `isEdited`
  const setEdited = (flag) => {
    if (flag !== undefined) {
      adminAppDispatcher({ type: "SET_EDITED", payload: flag });
    }
  };
  const setEditedUserProv = (flag) => {
    adminAppDispatcher({ type: "SET_EDITED_USERPROV", payload: flag });
  };

  const setEditedSso = (flag) => {
    adminAppDispatcher({ type: "SET_EDITED_SSO", payload: flag });
  };
  const setCompanyName = (companyName) => {
    if (companyName) {
      adminAppDispatcher({ type: "COMPANY_NAME", payload: companyName });
    }
  };

  const setOpenedWindow = (windowName) => {
    if (windowName) {
      adminAppDispatcher({ type: "SET_OPENED_WINDOW", payload: windowName });
    }
  };
  // const setRefreshCallFlowNode = (nodeid) => {
  //   adminAppDispatcher({ type: "REFRESH_NODE", payload: nodeid });
  // };

  const getFinalJson = (JsonObj, formDataObj) => {
    adminAppDispatcher({
      type: "FINAL_JSON",
      payload: {
        jsonObj: JSON.stringify(JsonObj),
        formDataObj: JSON.stringify(formDataObj),
      },
    });
  };

  // Expose state and functions in the context
  const commonObj = {
    isEdited: adminAppState.isEdited,
    setEdited,
    openedWindow: adminAppState.openedWindow,
    setOpenedWindow,
    setCompanyName,
    companyName: adminAppState.companyName,
    isEditedUserProv: adminAppState.isEditedUserProv,
    setEditedUserProv,

    isEditedSso: adminAppState.isEditedSso,
    setEditedSso,
    // reFreshCallFlowNode: adminAppState.reFreshCallFlowNode,
    // setRefreshCallFlowNode,
  };

  return (
    <appContext.Provider value={commonObj}>{children}</appContext.Provider>
  );
};

function prepareFinalJson(dirtyFields, data) {
  const modifiedData = {};

  function recurse(dirtyFields, data, modifiedData) {
    for (const field of Object.keys(dirtyFields)) {
      if (dirtyFields[field] && data.hasOwnProperty(field)) {
        if (typeof data[field] === "object" && !Array.isArray(data[field])) {
          modifiedData[field] = {};
          recurse(dirtyFields[field], data[field], modifiedData[field]);
        } else {
          modifiedData[field] = data[field];
        }
      }
    }
  }

  recurse(dirtyFields, data, modifiedData);
  return modifiedData;
}
